import IntegrationType from "../../../../types/integration/IntegrationType";
import NotificationIntegrationList from "../NotificationIntegrationList";
import { NOTIFICATION_INTEGRATIONS } from "../../../../helpers/notificationIntegrations";

function List(props: { loading: number, webhooks: IntegrationType[], refresh: Function, isAdmin: boolean }) {
    return (
        <NotificationIntegrationList
            loading={props.loading}
            parameters={props.webhooks}
            refresh={props.refresh}
            isAdmin={props.isAdmin}
            config={NOTIFICATION_INTEGRATIONS.webhook}
            iconClass="fal fa-webhook"
            endpointLabel="Webhook URL"
            endpointKey="url"
        />
    );
}

export default List;
